import axios from 'axios';

export class CompanyService {
    getCompanyOnly = async () => {
        return await axios.get('/api/company/getallcompanyonly');
    };

    getapplicationcompanyonly = async (applicationId) => {
        return await axios.get('/api/company/getapplicationcompanyonly?applicationId=' + applicationId);
    }; 

    getCompanyTypes = async () => {
        return await axios.get('/api/companytype');
    };

    getcompanybyidtoedit = async (id) => {
        return await axios.get('/api/company/getcompanybyidtoedit?id=' + id);
    }

    updateCompany = async (companyModel) => {
        return await axios.post('/api/company/save', companyModel);
    }

    deleteCompany = async (id) => {
        return await axios.delete('/api/Company?id=' + id);
    }

    deleteCompanyRequest = async (id) => {
        return await axios.delete('/api/companyrequest/delete?id=' + id);
    }
}